import React from 'react';

export default ({ size }) => {
    const viewBox = size === 'l' ? '0 0 24 24' : '0 0 48 48';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewBox} fill="none">
            <path
                data-flippable="false"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18.0005 4H10.0005V7H6.00049V9.6044L4.6665 9.91971L4.66941 9.93198L4.66031 9.92944L2.00781 13.2451L4.00049 13.9186V18.3604L12.0005 21.027L20.0005 18.3604V13.5239L21.9795 12.7082L19.3421 9.41138L19.3263 9.41687L19.3272 9.41007L18.0616 9.25382C18.041 9.25129 18.0207 9.25003 18.0005 9.25V4ZM7.00049 10.5835L11.9841 11.9763L13.0005 11.6219V8H7.00049V10.5835ZM11.0005 7H14.0005V11.2734L17.0005 10.2276V5H11.0005V7ZM11.5005 13.7932L9.6503 15.8284L5.00049 14.2567V17.6396L11.5005 19.8063V13.7932ZM19.0005 13.9361L14.3668 15.846L12.5005 13.793V19.8063L19.0005 17.6396V13.9361ZM14.6346 14.6539L12.8794 12.7232L19.0032 10.5885L20.3657 12.2917L14.6346 14.6539ZM3.68056 12.7549L5.02806 11.0705L11.0853 12.7634L9.35057 14.6715L3.68056 12.7549Z"
            ></path>
        </svg>
    );
};
